import {routerHandler} from "../../../resources/utils/router";
import {StoreViewInfoComponent} from "./store-view-info/store-view-info.component";
import {StoreViewProjectsComponent} from "./store-view-projects/store-view-projects.component";
import {StoreViewPurchasesComponent} from "./store-view-purchases/store-view-purchases.component";
import {StoreViewProductsComponent} from "./store-view-products/store-view-products.component";
import {StoreViewCollectionsComponent} from "./store-view-collections/store-view-collections.component";
import {StoreViewVersionsComponent} from "./store-view-versions/store-view-versions.component";
import {StoreViewActionsComponent} from "./store-view-actions/store-view-actions.component";
import {StoreViewUsersComponent} from "./store-view-users/store-view-users.component";
import {StoreEditComponent} from "../store-edit/store-edit.component";
import {Routes} from "@angular/router";
import {StoreViewSnapshotsComponent} from './store-view-snapshots/store-view-snapshots.component';
import {StoreViewCustomDataComponent} from './store-view-custom-data/store-view-custom-data.component';

export const StoreViewRoutesData = {
  'redirect': routerHandler.redirect('store'),
  'projects': routerHandler.projects('store', {component: StoreViewProjectsComponent}),
  'storeCollections': routerHandler.storeCollections('store', {component: StoreViewCollectionsComponent}),
  'products': routerHandler.products('store', {component: StoreViewProductsComponent}),
  'versions': routerHandler.versions('store', {component: StoreViewVersionsComponent}),
  'actions': routerHandler.actions('store', {component: StoreViewActionsComponent}),
  'users': routerHandler.users('store', {component: StoreViewUsersComponent}),
  'purchases': routerHandler.purchases('store', {component: StoreViewPurchasesComponent}),
  'snapshots': routerHandler.snapshots('store', {
    component: StoreViewSnapshotsComponent,
    permission: 'StoreViewSnapshotsComponent'
  }),
  'custom-data': routerHandler.customData('store', {component: StoreViewCustomDataComponent}),
  'info': routerHandler.info('store', {component: StoreViewInfoComponent}),
  'edit': routerHandler.edit('store', {component: StoreEditComponent}),
};

export const StoreViewRoutes: Routes = Object.values(StoreViewRoutesData);
